/**
 * @author leiling.cp
 * @version 2015.3.20
 * @description 工作台工具类
 */

var StoreProxy = require('@alife/alpha-store-proxy/store-proxy');

var STORE_MARKETING = 'webatm-marketing';

var Util = {
    getQueryString: function(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"),
            r = window.location.search.substr(1).match(reg);
        if (r != null) return window.unescape(r[2]);
        return null;
    },
    buildQuery: function(query) {
        if (query !== undefined && query !== "") {
            if (query.substring(0, 1) != "&") {
                return "&" + query;
            }
            return query;
        }
        return "";
    },
    getCookie: function(sKey) {
        return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
    },
    setCookie: function(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
        if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
            return false;
        }
        var sExpires = "";
        if (vEnd) {
            switch (vEnd.constructor) {
                case Number:
                    sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
                    break;
                case String:
                    sExpires = "; expires=" + vEnd;
                    break;
                case Date:
                    sExpires = "; expires=" + vEnd.toUTCString();
                    break;
            }
        }
        document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
        return true;
    },
    clearCookie: function(sKey, sPath, sDomain) {
        document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
        return true;
    },
    hashCode: function(uid) {
        var hash = 0,
            i, chr, len;
        if (uid.length == 0) return hash;
        for (i = 0, len = uid.length; i < len; i++) {
            chr = uid.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0;
        }
        return Math.abs(hash);
    },
    getUserId: function() {
        var self = this,
            loginFlag = self.getCookie("xman_us_t"),
            start = String(loginFlag).indexOf("x_lid="),
            userId = "";

        if (!!loginFlag) {
            if (start >= 0) {
                start += 6;
                loginFlag = loginFlag.substring(start);
                var end = loginFlag.indexOf("&");
                if (end > 0) {
                    userId = loginFlag.substring(0, end);
                } else {
                    userId = loginFlag;
                }
            }
        }

        userId = userId ? userId : self.getCookie("cna");
        return userId;
    },
    /**
     * 保存营销数据
     *
     * data: {
     *     contactId: data.result,
     *     marketingId: marketingId,
     *     type: marketType,
     *     message: message,
     *     productId: productId,
     *     country: country,
     *     originTime: originTime
     * }
     *
     * @param {Number} contactId 联系人ID
     * @param {Object} data      营销数据
     */
    saveMarketingData: function (contactId, data) {

        StoreProxy.get(STORE_MARKETING, function (err, raw) {
            var obj = {};

            if (!err) {
                try {
                    obj = JSON.parse(raw);
                } catch (e) {
                    // empty
                }

                if (typeof obj !== 'object') {
                    obj = {};
                }
            }

            obj[contactId] = data;

            StoreProxy.set(STORE_MARKETING, JSON.stringify(obj), function (err) {
                if (err) {
                    /*@debug
                     console.log('save failed:', err);
                     */
                }
            });
        });
    }
};

module.exports = Util;
